module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Interview","tag":"Video interview","next":"Next"}}')
  delete Component.options._Ctor
}
